import { render, staticRenderFns } from "./online_purchase_edit.vue?vue&type=template&id=07936728&scoped=true"
import script from "./online_purchase_edit.vue?vue&type=script&lang=js"
export * from "./online_purchase_edit.vue?vue&type=script&lang=js"
import style0 from "./online_purchase_edit.vue?vue&type=style&index=0&id=07936728&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07936728",
  null
  
)

export default component.exports